module.exports = __webpack_public_path__ + "static/DEEP-2ae88e79996fb49859fea26cd63fcfab.jpg";